export default __webpack_public_path__ + "static/media/linkedin_icon.dd94fe14.svg";